import { Box, Typography, Divider, Link, ArrowForwardIcon } from "src/components";
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from 'src/hooks';

export default function SettingsLinkGroup({ title, items }) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const isInternalLink = (href) => href?.startsWith('/');

  return (
    <>
      <Typography variant="h6" mt={3} mb={1}>{title}</Typography>

      <Box sx={{ p: 0 }}>
        {items.map((item, idx) => (
          <Box key={item.label}>
            {item.action ? (
              <Link
                onClick={item.action}
                underline="none"
                sx={{
                  display: 'block',
                  cursor: 'pointer',
                  py: 0.5,
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography color={item.color || "primary.main"} variant={isMobile ? "subtitle1" : "body2"} fontWeight={600}>
                    {item.label}
                  </Typography>
                  {item.showArrow && <ArrowForwardIcon fontSize="small" />}
                </Box>
              </Link>
            ) : (
              <Link
                href={item.href}
                underline="none"
                sx={{
                  display: 'block',
                  cursor: 'pointer',
                  py: 0.5,
                }}
                {...(isInternalLink(item.href) && {
                  onClick: (e) => {
                    e.preventDefault();
                    navigate(item.href);
                  },
                })}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography color={item.color || "primary.main"} variant={isMobile ? "subtitle1" : "body2"} fontWeight={600}>
                    {item.label}
                  </Typography>
                  {item.showArrow && <ArrowForwardIcon fontSize="small" />}
                </Box>
              </Link>
            )}

            {idx < items.length - 1 && <Divider />}
          </Box>
        ))}
      </Box>
    </>
  );
}
